import { render, staticRenderFns } from "./AdminSidebar.vue?vue&type=template&id=d5938310"
import script from "./AdminSidebar.vue?vue&type=script&lang=js"
export * from "./AdminSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5938310')) {
      api.createRecord('d5938310', component.options)
    } else {
      api.reload('d5938310', component.options)
    }
    module.hot.accept("./AdminSidebar.vue?vue&type=template&id=d5938310", function () {
      api.rerender('d5938310', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminSidebar.vue"
export default component.exports